import { CalendarCheck, CreditCard, QrCode } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { useLang } from "../i18n/LanguageContext";

const ICONS = [CalendarCheck, CreditCard, QrCode];

export const HowItWorks = () => {
  const { t } = useLang();
  return (
    <section id="how" className="relative overflow-hidden bg-[var(--ink)] py-24 text-white sm:py-32" data-testid="how-it-works">
      <div className="grain absolute inset-0" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHead eyebrow={t.how.eyebrow} title={t.how.title} light />
        <ol className="mt-16 grid gap-4 md:grid-cols-3 md:gap-6">
          {t.how.steps.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={i} delay={i * 0.12}>
                <li className="group relative h-full rounded-[1.6rem] border border-white/10 bg-white/[0.04] p-7 transition-colors duration-300 hover:bg-white/[0.08] sm:p-8" data-testid={`step-${i + 1}`}>
                  <span className="font-display absolute right-6 top-5 text-6xl font-extrabold leading-none text-white/[0.06] transition-colors duration-300 group-hover:text-[var(--coral)]/30">0{i + 1}</span>
                  <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[var(--coral)] text-white shadow-[0_12px_30px_-10px_rgba(255,90,54,.7)]"><Icon className="h-6 w-6" /></span>
                  <h3 className="font-display mt-8 text-xl font-bold tracking-tight sm:text-2xl">{s.t}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-white/65 sm:text-base">{s.d}</p>
                </li>
              </Reveal>
            );
          })}
        </ol>
      </div>
    </section>
  );
};
